import Employees from "./pages/employees/store";
import generalInfo from "./pages/general-info/store";
import meeting from "./pages/meetings/store";
import GeneralAuthority from "./pages/general-authority/store";
import AdministrationService from "./services";
import Transactions from "@/modules/ngo/transactions/store";
import GeneralAuthorityMeeting from "./pages/hold-general-body-meeting/store";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  modules: {
    Employees,
    generalInfo,
    meeting,
    GeneralAuthority,
    Transactions, 
    GeneralAuthorityMeeting
  },
  state: {
    loading: false,
    councilsLoading: false,
    councils: [],
    memberCount :0 ,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    councilsLoading(state) {
      return state.councilsLoading;
    },
    councils(state) {
      return state.councils;
    },
    memberCount(state) {
      return state.memberCount;
    },
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
    setLoadingCouncils(state, val) {
      state.councilsLoading = val;
    },
    setCouncils(state, val) {
      state.councils = val;
    },
    setMemberCount(state, val) {
      state.memberCount = val;
    },
  },
  actions: {
    async fetchMemberCount({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await AdministrationService.fetchMemberCount(payload);
        commit("setLoading", false);
        commit("setMemberCount" , res.data.pagination.total_row)

        if (hasError(res.status)) {
          throw res.statusText;
        }
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
    async addMember({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await AdministrationService.addMember(payload);
        commit("setLoading", false);

        if (hasError(res.status)) {
          throw res.statusText;
        }
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
    async updateMember({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await AdministrationService.updateMember(payload);
        commit("setLoading", false);

        if (hasError(res.status)) {
          throw res.statusText;
        }
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
    async deleteMember({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await AdministrationService.deleteMember(payload);
        commit("setLoading", false);

        if (hasError(res.status)) {
          throw res.statusText;
        }
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
    async addCouncil({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await AdministrationService.addCouncil(payload);
        commit("setLoading", false);

        if (hasError(res.status)) {
          throw res.statusText;
        }
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
    async updateCouncil({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await AdministrationService.updateCouncil(payload);
        commit("setLoading", false);

        if (hasError(res.status)) {
          throw res.statusText;
        }
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
    async deleteCouncil({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await AdministrationService.deleteCouncil(payload);
        commit("setLoading", false);

        if (hasError(res.status)) {
          throw res.statusText;
        }
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
    async fetchCouncils({ commit }, payload) {
      commit("setLoadingCouncils", true);
      try {
        const res = await AdministrationService.fetchCouncils(payload);
        commit("setLoadingCouncils", false);

        if (hasError(res.status)) {
          throw res.statusText;
        }
        commit("setCouncils", res.data.data);
        commit("setMemberCount" , res.data.pagination.total_row)
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
  },
};
